import { useCallback } from 'react';

import { useUserProfile } from '../providers/UserProfileContext/UserProfileContext';
import { isAdminOrSales, isSales } from '../services/UserRole';
import { useApp } from './useApp';

interface AccessProps {
  isPermittedToAccessAdminPage: boolean;
  isSalesAccessingSameDistributorRequest: (
    request: SimpleProjectServiceAPI.ConfigurationRequestDto,
  ) => boolean;
}

export const useAccess = (): AccessProps => {
  const { userData } = useUserProfile();
  const { roles } = useApp();
  const isPermittedToAccessAdminPage = isAdminOrSales(roles);

  const isSalesAccessing = isSales(roles);

  const isSalesAccessingSameDistributorRequest = useCallback(
    (request: SimpleProjectServiceAPI.ConfigurationRequestDto) => {
      return isSalesAccessing && request?.distributor === userData?.distributor;
    },
    [isSalesAccessing, userData?.distributor],
  );

  return { isPermittedToAccessAdminPage, isSalesAccessingSameDistributorRequest };
};
